export { DoctorHeroSection } from './DoctorHeroSection';
export { DoctorFeaturesSection } from './DoctorFeaturesSection';
export { DoctorBenefitsSection } from './DoctorBenefitsSection';
